import { useCallback } from 'react';
/**
 * Takes an automationId eg: "submit-button" and returns a callback.
 *
 * The returned callback takes a trace suffix eg: "title" and returns a string eg: "submit-button-title".
 * @export
 * @param {string} automationId
 * @return {*}
 */
export function useTrace(automationId) {
    // Takes a suffix eg: "title" and returns a string eg: "submit-button-title".
    const getFullTrace = useCallback((traceSuffix) => {
        if (traceSuffix) {
            return `${automationId}-${traceSuffix}`;
        }
        return `${automationId}`;
    }, []);
    return getFullTrace;
}
//# sourceMappingURL=trace.js.map